<template>
  <ValidationObserver ref="validator">
    <form novalidate class="md-layout generic-form" @submit.prevent="validate">
      <div class="md-layout-item md-medium-size-100 md-size-60" :class="$attrs.targetClass">
        <md-card>
          <md-card-content>
            <!-- {{ data }} -->
            <slot v-bind:data="queriedData" v-if="data" />
            <md-button v-if="creationEnabled" @click="addItem">Add</md-button>
          </md-card-content>
          <md-card-actions>
            <slot name="paginator">
              <pagination
                v-if="paginationEnabled && Array.isArray(this.data) && pagination.perPage < total"
                class="pagination-no-border pagination-primary"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
              >
              </pagination>
            </slot>
            <md-button class="md-success" type="submit">Save</md-button>
          </md-card-actions>
        </md-card>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import Pagination from '@/components/Pagination.vue'

export default {
  name: 'GenericForm',
  props: {
    endpoints: Object,
    creationEnabled: Boolean,
    paginationEnabled: Boolean,
    loadOnInit: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    Pagination,
  },
  computed: {
    queriedData() {
      if (this.paginationEnabled) return this.data.slice(this.from, this.to)

      return this.data
    },
    to() {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    total() {
      return Array.isArray(this.data) ? this.data.length : 0
    },
  },
  data() {
    return {
      data: this.loadOnInit ? null : [],
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
    }
  },
  methods: {
    async validate() {
      const isValid = await this.$refs.validator.validate()

      if (isValid) return this.update()

      this.$notify({
        timeout: 2500,
        message: '<strong>Not saved</strong>. Please check your inputs',
        icon: 'check_box',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'danger',
      })
    },
    update() {
      this.endpoints.update(this.$root.hotelId, this.data, (error, data, response) => {
        if (!error) {
          this.data = data
          this.$root.$emit('saved')
        }
      })
    },
    reload() {
      this.$nextTick().then(() => {
        if (this.endpoints.get && typeof this.endpoints.get === 'function')
          this.endpoints.get((error, data) => {
            if (!error) this.data = data
          })
      })
    },
    addItem() {
      var newItem = { id: 0 }
      if (typeof this.$parent.constructNewItemFromObject === 'function') newItem = this.$parent.constructNewItemFromObject(newItem)

      this.data.push(newItem)
    },
  },
  created() {
    if (this.loadOnInit) this.reload()
  },
}
</script>

<style lang="scss">
.generic-form {
  label {
    color: #aaa;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.4;
    display: block;
  }
}
</style>
